import { WatchQueryFetchPolicy } from '@apollo/client';
import { useQuery } from '@apollo/client/react';
import { CUSTODIAL_PROVIDERS } from '@constants';
import { MeQuery, MeQueryVariables } from './__generated__/MeQuery';
import ME_QUERY from './MeQuery.graphql';

const useMe = (options?: {
  fetchPolicy?: WatchQueryFetchPolicy;
  include?: MeQueryVariables;
  skip?: boolean;
}) => {
  const { data, error, loading, previousData, refetch } = useQuery<MeQuery, MeQueryVariables>(
    ME_QUERY,
    {
      fetchPolicy: options?.fetchPolicy || 'cache-only',
      variables: options?.include,
      skip: options?.skip,
    },
  );

  const me = data?.me || previousData?.me;

  let custodialProvider;
  if (me?.enterprise) {
    custodialProvider = me.enterprise.bridgeCustomerId ? CUSTODIAL_PROVIDERS.BRIDGE : null;
  }

  return { me, error, loading, refetch, custodialProvider };
};

export default useMe;
